<template>
  <div class="text-xs-center">
    <v-dialog
      v-model="show"
      width="40%"
    >
      <v-card>
        <v-card-title
          class="headline pb-1"
          primary-title
        >
          {{ dialogTitle }}
        </v-card-title>

        <v-card-text class="pt-0">
          <v-form ref="usageForm" @submit.prevent="didApply">
            <v-text-field
              label="Prepared for"
              v-model="customerName"
              :rules="[rules.required]"
              autofocus
              required
            >
            </v-text-field>
            
            <v-select
              v-model="usePurpose"
              :items="usePurposes"
              label="Purpose for today's session"
              item-text="name"
              item-value="value"
              required
            >
            </v-select>
            
            <v-text-field
              label="Other (please specify)"
              v-model="customUsePurpose"
              v-if="usePurpose=='_other'"
              maxlength="140"
              autofocus
              required
            >
            </v-text-field>
            
            <div 
              class="star-rating-input-group"
            >
              <label>
                How did it go?
              </label>
              <star-rating
                v-model="rating"
                :show-rating="false"
                :star-size="25"
              >
              </star-rating>
            </div>
            
            <v-textarea
              box
              v-model="comments"
              label="Comments/Ideas (optional)"
              counter
              maxlength="140"
            >
            </v-textarea>
            
            <v-btn type="submit" style="display:none;">Submit</v-btn>
          </v-form>
          
          <!--v-btn type="submit" @click="findSessions()">findSess</v-btn-->
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="closeDialog()"
          >
            Cancel
          </v-btn>
          <v-btn
            color="primary"
            flat
            @click="didApply()"
            :disabled="!surveyCompleted"
          >
            Submit
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
export default {
  name: 'session-usage-survey',
  data () {
    return {
      customerName: '',
      usePurpose: '',
      customUsePurpose: '',
      rating: 0,
      comments: '',
      usePurposes: [
        { name: "Practicing", value: "_practicing" },
        { name: "Sharing with a client", value: "_sharing_client" },
        { name: "Consulting with my client", value: "_consulting" },
        { name: "Sharing with my colleague", value: "_sharing_colleague" },
        { name: "Other", value: "_other" }
      ],
      rules: {
        required: value => !!value || 'Required.'
      }
    }
  },

  props: {
    show: Boolean,
    sessionToUpdate: Object
  },

  methods: {
    closeDialog() {
      this.rating = 0
      this.$refs.usageForm.reset()
      this.$emit('close-dialog')
    },
    didApply() {
      if(!this.surveyCompleted){
        return
      }
      
      let returnObj = { 
        customerName: this.customerName,
        score: this.rating || 0,
        usePurpose: (this.usePurpose == "_other" ? this.customUsePurpose : this.usePurpose),
        comments: this.comments
      }
      if(this.sessionToUpdate && this.sessionToUpdate.sessionId){
        returnObj.sessionId = this.sessionToUpdate.sessionId
      }

      this.$emit('did-apply', returnObj)
    },
    findSessions() {
      this.$store.dispatch('findSessions')
    }
  },

  computed: {
    surveyCompleted() {
      return this.customerName && this.customerName.length 
        && this.usePurpose && this.usePurpose.length
        && (this.usePurpose != "other" 
          || (this.usePurpose == "other" && this.customUsePurpose && this.customUsePurpose.length))
    },
    sessionId() {
      return this.$store.getters.sessionId
    },
    dialogTitle(){
      return this.sessionToUpdate && this.sessionToUpdate.sessionStartTime 
        ? "How did it go on " + new Date(this.sessionToUpdate.sessionStartTime).toLocaleDateString() + "?" : "Complete this information to create your custom PDF"
    }
  },

  watch: {
  },

  components: {
    'star-rating': () => import ('vue-star-rating')
  }
}

</script>

<style scoped>
.star-rating-input-group {
  padding-bottom: 12px;
}
.star-rating-input-group label {
  font-size: 13px;
  color: rgba(0,0,0,.54);
}
</style>